// @core/api/endpoints/userprofile/get_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AvatarResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get avatar by ID
 * Retrieves avatar metadata and image URL by its ID. Only the profile owner can access their avatar details.
 */
export async function GetAvatar(
  profile_id: string,
  avatar_id: string,
  options?: RequestOptions
): Promise<AvatarResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/avatars/:avatar_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  requestPath = requestPath.replace(':avatar_id', encodeURIComponent(avatar_id));
  const requestOptions = options;
  return client.get<AvatarResponse>(requestPath, { ...requestOptions });
}
